import React from "react";

const OrdersRatings = () => {
  return <div>OrdersRatings</div>;
};

export default OrdersRatings;
